import { render } from "./ButtonComponent.vue?vue&type=template&id=60ade6ec&scoped=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=js"
export * from "./ButtonComponent.vue?vue&type=script&lang=js"

import "./ButtonComponent.vue?vue&type=style&index=0&id=60ade6ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-60ade6ec"

export default script